import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class InspectionTypesLookupModel extends ModelBase<InspectionTypesLookupModel, any> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = InspectionTypesLookupModel.DEFAULT_ID;

    @observable
    public displayName: string = InspectionTypesLookupModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = InspectionTypesLookupModel.DEFAULT_ID;
        this.displayName = InspectionTypesLookupModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: InspectionTypesDTO): void {
        this.id = dto.id;
        this.displayName = dto.displayName;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: InspectionTypesDTO[]): InspectionTypesLookupModel[] {
        const types: InspectionTypesLookupModel[] = [];

        for (const dto of dtos) {
            const model = new InspectionTypesLookupModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface InspectionTypesDTO {
    id: string;
    displayName: string;
}
